import { FormattedMessage } from '@alltrails/shared/react-intl';
import PurchaseTier from 'types/PurchaseTier';

const getCtaText = (tierSelected: PurchaseTier, isPromoEligible?: boolean) => {
  if (isPromoEligible) {
    return <FormattedMessage defaultMessage="Start your free trial" />;
  }

  if (tierSelected === 'peak') {
    return <FormattedMessage defaultMessage="Continue with Peak" />;
  }

  return <FormattedMessage defaultMessage="Continue with Plus" />;
};

export default getCtaText;
